/**
 * Euro-Darstellung für Beleg, Rechnung und Anzeige (Cent → Text). Reines Modul ohne
 * Abhängigkeiten, damit auch die Kassen-App es einbinden kann. Der maschinenlesbare Code nutzt
 * dagegen `formatiereBetrag` (ohne Tausenderpunkt, Regel 5).
 */

/** Cent → "1.234,56" / "-2,60" (Anzeige; der RKSV-Code nutzt formatiereBetrag ohne Tausenderpunkt). */
export function formatiereEuro(cent: number): string {
  if (!Number.isInteger(cent)) {
    throw new TypeError('Betrag muss ganzzahliger Cent-Wert sein');
  }
  const negativ = cent < 0;
  const absolut = Math.abs(cent);
  const euro = String(Math.trunc(absolut / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const rest = String(absolut % 100).padStart(2, '0');
  return `${negativ ? '-' : ''}${euro},${rest}`;
}
